import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { cn } from "../../lib/utils";

type AppDatePickerProps = {
  label?: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
  error?: string;
  className?: string;
  minDate?: Date;
  maxDate?: Date;
};

const AppDatePicker: React.FC<AppDatePickerProps> = ({
  label,
  value,
  onChange,
  error,
  className,
  minDate,
  maxDate,
}) => {
  const datePickerRef = useRef<DatePicker>(null);

  const handleCalendarOpen = () => {
    // Add a class to body to prevent other interactions
    document.body.classList.add("datepicker-open");
  };

  const handleCalendarClose = () => {
    // Remove the class when calendar closes
    document.body.classList.remove("datepicker-open");
  };

  return (
    <div className="flex flex-col space-y-1 text-[13px] mb-2 relative z-50">
      {label && <label className="mb-2 font-semibold">{label}</label>}
      <DatePicker
        ref={datePickerRef}
        selected={value}
        onChange={onChange}
        dateFormat="yyyy-MM-dd"
        className={cn(
          "w-full h-[56px] px-4 py-3 border border-[#BDBDBD] rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all",
          error && "border-primary focus:border-primary focus:ring-primary",
          className,
        )}
        placeholderText="Select date"
        minDate={minDate}
        maxDate={maxDate}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        popperClassName="z-[9999]"
        // popperPlacement="bottom-start"
        // wrapperClassName="relative"
        calendarClassName="shadow-lg border border-gray-200 rounded-lg"
        onCalendarOpen={handleCalendarOpen}
        onCalendarClose={handleCalendarClose}
        onClickOutside={handleCalendarClose}
      />
      {error && <span className="text-xs text-primary">{error}</span>}
    </div>
  );
};

export default AppDatePicker;
